import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var defaultProps = {};
var styleOverrides = {
  root: function root(_ref) {
    var _MuiToolbarRoot;
    var theme = _ref.theme;
    return {
      '& > .MuiToolbar-root': (_MuiToolbarRoot = {
        minHeight: 64,
        '& > .MuiIconButton-root': {
          '& > .MuiSvgIcon-root': {
            width: 32,
            height: 32
          }
        }
      }, _defineProperty(_MuiToolbarRoot, theme.breakpoints.up('sm'), {
        minHeight: 80
      }), _defineProperty(_MuiToolbarRoot, theme.breakpoints.up('md'), {
        minHeight: 123,
        '& .LumaAppBarPatientBoxLogo-root > img': {
          maxHeight: 44,
          maxWidth: 'none'
        }
      }), _MuiToolbarRoot)
    };
  }
};
export default {
  defaultProps: defaultProps,
  styleOverrides: styleOverrides
};